import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { IBasicInfo, IFundraiser } from 'src/app/fundraiser/models/fundraiser.model';
import { FundraiserSliderImgModule } from '../fundraiser-slider-img/fundraiser-slider-img.module';
import { FundraiserService, UtilService, VariablesService } from 'src/app/shared/services';
import { CommonFundraiserModule } from '../common-fundraiser/common-fundraiser.module';

@Component({
  selector: 'app-preview-fundraiser',
  standalone: true,
  imports: [
    CommonModule,
    FundraiserSliderImgModule,
    CommonFundraiserModule
  ],
  templateUrl: './preview-fundraiser.component.html',
  styleUrls: ['./preview-fundraiser.component.scss']
})
export class PreviewFundraiserComponent {
  constructor(
    private actRoute: ActivatedRoute,
    public fundraiserService: FundraiserService,
    private util: UtilService,
    public vars: VariablesService,
    private router: Router
  ) {}
  basicInfo: IBasicInfo = {};
  isFos = false;
  fundraiser:IFundraiser;
  isMobile = false;
  currency;
  subs = [];
  isFundraiserEnded;

  isLoading :boolean = true;
  
  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.getCurrency();
  }

  getCurrency() {
    this.subs.push(this.util.currency.subscribe((res) => {
      if (res) {
        this.currency = res;
        this.getParams();
      }
    }));
  }

  getParams() {
    this.actRoute.params.subscribe(params => {
      const draftId = params['id'];
      this.isLoading = true;
      this.getFundraiser(draftId);
    });
  }

  getFundraiser(campaignId) {
    const qParam = `?with=viewmedicalbill;gallery;basicinfo;validCoupon.redeemTransferApply;foscampaign;verifiedCampaign;sipcause;`
    .concat(`beneficiary.avtar;campaigner.avtar;activeteam.member.avtar;activeteam.member.sociallinks;organiser;tipModel;isStory;`)
    .concat(`rewards;banktransfer;cause;campaigner.social;campaigner.aggFundraiser;campaigner.aggdonation;mediaBeneficiary;multiCampaigns;beneficiaryname;userFollowed;fbShareCount`)
    .concat(`;matchingDonor;googleIndex&currency=${this.currency}&page_type=${this.vars.pageName}`);
    this.fundraiserService.getCampaignDetails(campaignId, qParam).subscribe({ next: (res: any) => {
      if ((res.data && res.data.foscampaign && res.data.foscampaign.info_1 === '1' &&
        res.data.verified_campaign && res.data.verified_campaign.info_1 === '1') || res.data.parent_cause_id === 149) {
        this.isFos = true;
      }
      this.fundraiser = res.data;
      this.setBasicInfo(this.fundraiser.basicinfo);
      this.setTitle();
      this.isFundraiserEnded = this.util.checkFundraiserEnded(this.fundraiser.status_flag, this.fundraiser.end_date);
      if (this.fundraiser.custom_tag) {
        this.fundraiserService.getCampaign(`${this.fundraiser.custom_tag}/raised`, `?currency=${this.currency}&page_type=${this.vars.pageName}`, 'false')
        .subscribe((res2: any) => {
          this.isLoading = false;
          this.fundraiser.raised = res2?.data?.raised;
          this.fundraiser.raised.beforeTickrBackers = this.fundraiser.raised ? this.fundraiser.raised.backers : 0;
        });
      }else{
        this.isLoading = false;
      }
    }, error: (error) => {
        this.isLoading = false;
        if (error.error.data.message === 'Restricted Access') {
          this.util.openSnackBar('Restricted Access', 'DISMISS');
          this.router.navigate(['/']);
        }
      }
    });
  }

  setBasicInfo(data: any[]) {
    if (data && data.length) {
      for (const item of data) {
        this.basicInfo[item.info_type] = item.info_1 || '';
      }
      this.vars.basicInfo = this.basicInfo;
    }
  }
  setTitle() {
    this.util.setPageTitle(this.fundraiser.title);
  }
}
